//https://github.com/angular/angular.js/pull/10732

var angular = require('angular');
var mask = require('./dist/mask');

module.exports = 'ui.mask';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-ui-mask/index.js
 ** module id = 207
 ** module chunks = 0
 **/